<template>
    <div class="base-pwd" :class="{'pwd-sp': $store.state.screen == 1}">
        <div class="content">
            <div class="title">支付密码</div>
            <input class="val" type="text" maxlength="16" placeholder="请输入支付密码" v-model="pwd" />
            <div class="btn">
                <div class="item" @click="onOut">取消</div>
                <div class="item" @click="submit">确定</div>
            </div>
            <transition name="component-fade" mode="out-in">
                <TheTips :msg='msg' v-if="msg" />
            </transition>
        </div>
    </div>
</template>

<script>
    import TheTips from '@/components/TheTips'

    export default {
        components: {
            TheTips
        },
        data () {
            return {
                msg: null,
                pwd: ''
            }
        },
        methods: {
            // 关闭弹窗
            onOut () {
                this.$emit('childPwd', 0)
            },
            // 验证支付密码
            submit () {
                if (!this.pwd.replace(/\s*/g, "")) {
                    this.msg = '密码不能为空'
                    setTimeout(() => {
                        this.msg = null
                    }, 2000)
                    return false
                }
                if (this.pwd.replace(/\s*/g, "").length < 6 || this.pwd.replace(/\s*/g, "").length > 16) {
                    this.msg = '请输入6~16个字符'
                    setTimeout(() => {
                        this.msg = null
                    }, 2000)
                    return false
                }
                let accountData = JSON.parse(sessionStorage.getItem('accountData'))
                let options = {
                    uid: accountData.uid,
                    appid: accountData.appid,
                    channel: accountData.channel,
                    system: this.config.system,
                    pay_password: this.pwd
                }
                options.sign = this.util.getSign(options, accountData.appkey)
                this.$axios.post('http://sdk.gameschain.pro/index.php?g=api&m=user&a=check_pay_pass',this.$qs.stringify(options)).then(res => {
                    if (res.data.status == 1) {
                        this.$emit('childPwd', 1)
                    } else {
                        this.msg = res.data.msg
                        setTimeout(() => {
                            this.msg = null
                        }, 2000)
                    }
                }).
                catch(o => {
                    this.msg = '请求失败'
                    setTimeout(() => {
                        this.msg = null
                    }, 2000)
                })
            }
        }
    }
</script>

<style lang="scss" scoped>
    @import "../../../static/tctransition";
    $color: #FF6C22; // 主体颜色
    // 横屏css
    .base-pwd {
        width: 100%;
        height: 100%;
        background: rgba(0, 0, 0, 0.8);
        transition: all 0.3s;
        position: fixed;
        top: 0;
        left: 0;
        z-index: 999;
        .content {
            width: 840px;
            overflow: hidden;
            border-radius: 18px;
            background: $color;
            overflow: hidden;
            padding: 0 60px 60px;
            position: relative;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            .title {
                height: 160px;
                font-size: 51px;
                display: flex;
                align-items: center;
                justify-content: center;
            }
            .val {
                width: 100%;
                height: 120px;
                color: #fff;
                font-size: 39px;
                border-radius: 18px;
                border: 0;
                background: rgba(255, 255, 255, 0.2);
                padding: 0 45px;
                outline: none;
            }
            input::-webkit-input-placeholder{
                color:rgba(255, 255, 255, 0.5);
            }
            input::-moz-input-placeholder{
                color:rgba(255, 255, 255, 0.5);
            }
            input::-ms-input-placeholder{
                color:rgba(255, 255, 255, 0.5);
            }
            input::-o-input-placeholder{
                color:rgba(255, 255, 255, 0.5);
            }
            .btn {
                height: 120px;
                margin-top: 55px;
                display: flex;
                justify-content: space-between;
                .item {
                    width: 345px;
                    height: 120px;
                    color: $color;
                    font-size: 39px;
                    border-radius: 18px;
                    background: #fff;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                }
                .item:first-child {
                    background: rgba(255, 255, 255, 0.8);
                }
            }
        }
    }
    // 竖屏css
    .pwd-sp {
        .content {
            width: 1527px;
            border-radius: 32px;
            padding: 0 90px 90px;
            .title {
                height: 290px;
                font-size: 92px;
            }
            .val {
                height: 200px;
                font-size: 70px;
                border-radius: 32px;
                padding: 0 81px;
            }
            .btn {
                height: 200px;
                margin-top: 100px;
                .item {
                    width: 627px;
                    height: 200px;
                    font-size: 70px;
                    border-radius: 32px;
                }
            }
        }
    }
</style>